import React, { Component } from "react";
import ErrorAction from "../../../../../Redux/ErrorRedux";
import { connect } from "react-redux";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import FlexView from "react-flexview";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import FakturJualDetailHeader from "./fakturJualDetailHeader";
import FakturJualDetailContent from "./fakturJualDetailContent";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import withFormGroup from "../../../../../modules/commons/withFormGroup";
import FakturJualDetailDataInput from "./fakturJualDetailDataInput";
import { config } from "../config";
import {
  contructQueryParam,
  fetchDataAsync,
} from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { service } from "../service";
import { HttpStatus } from "../../../../common/Constants";
import { mapToObjectDDL } from "../../../../common/mapper";
import M from "moment";
import { v4 as uuidv4 } from "uuid";
import SimpleAlert from "../../../../../modules/popup/SimpleAlert";
import {
  calculateFakturJualViolations,
  getOldestUnit,
  isOlderThanOldestUnit,
} from "./violationRules";
import { fetchAvailableSalesOrderUnits } from "./unitAvailability";
import { fetchSalesProgramOptions } from "./salesProgramOptions";

class FakturJualDetail extends Component {
  constructor(props) {
    super(props);
    this.user = this.props.user;
    this.marketingLine = this.user?.marketingLine;
    this.adminLine = this.user?.administrationLine;
    this.state = {
      loading: false,
      inputDataVisible: false,
      mkValidationVisible: false,
      inputDataType: null,
      errors: {},
      namaPenjual: null,
      data: {
        nomorFakturJual: uuidv4(),
        tanggalFakturJual: M(new Date()).format("DD-MM-YYYY"),
        jenisProspect: "NEW",
        kodeCabang: this.props.state.kodeCabang,
        dataPemilik: config.initialDataPemilik,
        dataPembeli: config.initialDataPembeli,
        dataPhoto: config.initialDataPhoto,
        dataUnit: config.initialDataUnit,
        dataPackage: {
          selectedPackage: null,
          selectedRow: null,
          dataTable: {
            ksu: [],
            hadiah: [],
            barangLain: [],
            part: [],
          },
          dataDetailSaved: {
            ksu: [],
            hadiah: [],
            barangLain: [],
            part: [],
          },
        },
        dataTransaction: config.initialDataTransaction,
        dataDelivery: config.initialDataDelivery,
        dataReferral: config.initialDataReferal,
        dataNote: config.initialDataNote,
        fjState: null,
        statusForCancel: [],
        additionalError: null,
        showAlert: false
      },
      alertCancelOrDelete: null,
      isPoExist: false,
      istIdPelanggaran: [],
      alertInfo:{
        visible: false,
        title: null,
        content: null
      },
      listIdPelanggaran: []
    };
  }

  componentDidMount = async () => {
    this.setState((prevState) => ({
      ...prevState,
      statusForCancel: [
        "FJ_APPROVED",
        "FJ_SUBMITTED",
        "WAREHOUSE_PDI",
        "WAREHOUSE_PDI_REJECTION",
        "ADH_DELIVERY",
        "HANDOVER_UNIT_FAILED",
        "SSU_SUBMISSION",
      ],
    }));
    const { selectedData } = this.props.state;
    if (selectedData) {
      this.handleTriggerLoading();
      await this.fetchDataDetail();
      this.handleTriggerLoading();
    }
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  handleValueChange = (name, value, tab) => {
    this.setState((prevState) => ({
      ...prevState,
      data: {
        ...prevState.data,
        [tab]: {
          ...prevState.data[tab],
          [name]: value,
        },
      },
    }));
  };

  handleInputDataVisibility = (type) => {
    this.setState((prevState) => ({
      ...prevState,
      inputDataVisible: !prevState.inputDataVisible,
      inputDataType: type,
    }));
  };

  handleSelectInputData = (data, type) => {
    const update = {
      ...this.state.data,
    };

    if (type === "Indent") {
      update.indentNo = data.indentNo;
      update.prospectNo = data.prospectId || null;
    } else {
      update.prospectNo = data.prospectNo != null ? data.prospectNo : null;
    }

    if (data?.jenisProspect) {
      update.jenisProspect = data.jenisProspect;
    }

    this.setState((prevState) => ({
      ...prevState,
      data: update,
    }));

    this.handleInputDataVisibility();
  };

  handleSetState = (callback) => {
    this.setState(callback);
  };

  getDataSales = async (empId, cabangCode) => {
    try {
      const idUser = localStorage.getItem("userId");
      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA")
          .getDropDownListSalesForSalesOrder,
        setError: this.props.setError,
        menuName: "Faktur Jual - Sales Order",
        args: { idUser, kodeCabang: cabangCode || "" },
      });
      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        return res.data.data?.filter((item) => item?.employeeId === empId)[0]
          ?.name;
      }
      return null;
    } catch (error) {
      return null;
    }
  };

  shouldCalculateViolations = () => {
    const { tab, state } = this.props;
    const selectedData = state.selectedData;

    if (tab === "DGI") return true;

    return (
      tab === "NOS" &&
      (!selectedData || selectedData.salesOrderState === "FJ_DRAFT")
    );
  };

  fetchUnitAgeViolation = async (loadedData) => {
    const kodeCabang = loadedData?.kodeCabang?.value;
    const kodeVariant = loadedData?.dataUnit?.kodeVariant?.label;
    const idWarna = loadedData?.dataUnit?.idWarna?.value;
    const nomorRangka = loadedData?.dataUnit?.nomorRangka;
    const nomorMesin = loadedData?.dataUnit?.nomorMesin;

    if (!kodeCabang || !kodeVariant || !idWarna) return false;
    if (!nomorRangka && !nomorMesin) return false;

    const unitList = await fetchAvailableSalesOrderUnits({
      kodeCabang,
      kodeVariant,
      idWarna,
      setError: this.props.setError,
    });
    const selectedUnit = unitList.find((unit) => {
      const chassisMatches = !nomorRangka || unit?.noka === nomorRangka;
      const engineMatches = !nomorMesin || unit?.nosin === nomorMesin;

      return chassisMatches && engineMatches;
    });
    const oldestUnit = getOldestUnit(unitList);

    return isOlderThanOldestUnit(selectedUnit?.umur, oldestUnit?.umur);
  };

  fetchSelectedSalesProgram = async (loadedData) => {
    const pembayaranUnit =
      loadedData?.dataTransaction?.detailTransaction?.pembayaranUnit;
    const selectedPromoId = pembayaranUnit?.salesProgramId?.value;
    const kodeCabang = loadedData?.kodeCabang?.value;
    const kodeVariant = loadedData?.dataUnit?.kodeVariant?.value;
    const idWarna = loadedData?.dataUnit?.idWarna?.value;
    const promoType = pembayaranUnit?.tipePayment?.value;
    const downPayment = pembayaranUnit?.dpPo;
    const tenor = pembayaranUnit?.tenor;

    if (!selectedPromoId || !kodeCabang || !kodeVariant || !idWarna || !promoType) {
      return null;
    }

    if (
      promoType === "CREDIT" &&
      (downPayment === null ||
        downPayment === undefined ||
        tenor === null ||
        tenor === undefined)
    ) {
      return null;
    }

    const promoOptions = await fetchSalesProgramOptions({
      kodeCabang,
      promoType,
      kodeVariant,
      idWarna,
      leasingId: pembayaranUnit?.leasing?.value,
      downPayment,
      tenor,
      setError: this.props.setError,
    });

    return promoOptions.find((promo) => promo.value === selectedPromoId) || null;
  };

  fetchDataDetail = async () => {
    let promises = [];
    let response = {};
    let header = {};
    let headerViolationIds = [];
    const tabKey = this.props.tab;

    if (tabKey === "NOS") {
      const fakturNo = this.props.state.selectedData?.nomorFJ;
      let res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_TRANSACTION").getDataHeaderSalesOrderNOS,
        setError: this.props.setError,
        menuName: "Faktur Jual - Sales Order",
        args: contructQueryParam({ nomorFakturJual: fakturNo }),
      });

      if (res.ok && res.data.status === HttpStatus.FAILED) {
        this.props.onClickClose();
      }

      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        header = {
          nomorFakturJual: res.data.data.nomorFakturJual,
          tanggalFakturJual: res.data.data.tanggalFakturJual,
          kodeCabang: mapToObjectDDL(
            res.data.data.kodeCabang?.namaDealer,
            res.data.data.kodeCabang?.kodeCabang
          ),
          indentNo: res.data.data.nomorIndent,
          prospectNo: res.data.data.nomorProspek,
          jenisProspect: res.data.data.jenisProspek,
          statusFakturJual: "",
        };
        headerViolationIds = res.data.data?.idPelanggaranList || [];
      }

      promises.push(
        fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_TRANSACTION").getDetailBuyerSalesOrder,
          setError: this.props.setError,
          menuName: "Faktur Jual - Sales Order",
          args: contructQueryParam({ nomorFakturJual: fakturNo }),
        }),

        fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_TRANSACTION").getDetailOwnerSalesOrder,
          setError: this.props.setError,
          menuName: "Faktur Jual - Sales Order",
          args: contructQueryParam({ nomorFakturJual: fakturNo }),
        }),

        fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_TRANSACTION").getDetailPhotoSalesOrder,
          setError: this.props.setError,
          menuName: "Faktur Jual - Sales Order",
          args: contructQueryParam({ nomorFakturJual: fakturNo }),
        }),

        fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_TRANSACTION").getDetailUnitSalesOrder,
          setError: this.props.setError,
          menuName: "Faktur Jual - Sales Order",
          args: contructQueryParam({ nomorFakturJual: fakturNo }),
        }),

        fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_TRANSACTION").getDetailPackageSalesOrder,
          setError: this.props.setError,
          menuName: "Faktur Jual - Sales Order",
          args: contructQueryParam({ nomorFakturJual: fakturNo }),
        }),

        fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_TRANSACTION")
            .getDetailTransactionSalesOrder,
          setError: this.props.setError,
          menuName: "Faktur Jual - Sales Order",
          args: contructQueryParam({ nomorFakturJual: fakturNo }),
        }),

        fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_TRANSACTION")
            .getDetailDeliverySalesOrder,
          setError: this.props.setError,
          menuName: "Faktur Jual - Sales Order",
          args: contructQueryParam({ nomorFakturJual: fakturNo }),
        }),

        fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_TRANSACTION")
            .getDetailReferralSalesOrder,
          setError: this.props.setError,
          menuName: "Faktur Jual - Sales Order",
          args: contructQueryParam({ nomorFakturJual: fakturNo }),
        }),

        fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_TRANSACTION").getDetailNoteSalesOrder,
          setError: this.props.setError,
          menuName: "Faktur Jual - Sales Order",
          args: contructQueryParam({ nomorFakturJual: fakturNo }),
        })
      );

      response = await service.fetchDataDetail(tabKey, promises);
      if (response.error) {
        this.props.onClickClose();
      }
    }

    if (tabKey === "DGI") {
      const { nomorFJDgi, tanggalInvoice, dealerID } =
        this.props.state.selectedData;
      let cabang = this.props.state.cabangOptions.find(
        (c) => c.value === dealerID
      );

      header = {
        nomorFakturJual: nomorFJDgi,
        tanggalFakturJual: tanggalInvoice,
        jenisProspect: null,
        statusFakturJual: null,
        kodeCabang: cabang ? cabang : null,
      };

      promises.push(
        fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_DGI").getDataBuyerSODGI,
          setError: this.props.setError,
          menuName: "Faktur Jual - Sales Order",
          args: contructQueryParam({ nomorFakturJualDGI: nomorFJDgi }),
        }),

        fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_DGI").getDataOwnerSODGI,
          setError: this.props.setError,
          menuName: "Faktur Jual - Sales Order",
          args: contructQueryParam({ nomorFakturJualDGI: nomorFJDgi }),
        }),

        fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_DGI").getDataUnitSODGI,
          setError: this.props.setError,
          menuName: "Faktur Jual - Sales Order",
          args: contructQueryParam({ nomorFakturJualDGI: nomorFJDgi }),
        })
      );

      response = await service.fetchDataDetail(tabKey, promises);
      if (response.error) {
        this.props.onClickClose();
      }
    }

    const penjual = await this.getDataSales(
      response.data.dataTransaction?.headerTransaction?.salesPersonId?.value,
      header?.kodeCabang?.value
    );
    const loadedData = {
      ...header,
      ...response.data,
    };
    const shouldRecalculateOnLoad =
      tabKey === "NOS" &&
      this.props.state.selectedData?.salesOrderState === "FJ_DRAFT";
    let violationData = loadedData;

    if (shouldRecalculateOnLoad) {
      const selectedPromo = await this.fetchSelectedSalesProgram(loadedData);

      if (selectedPromo) {
        violationData = {
          ...loadedData,
          dataTransaction: {
            ...loadedData.dataTransaction,
            detailTransaction: {
              ...loadedData.dataTransaction.detailTransaction,
              pembayaranUnit: {
                ...loadedData.dataTransaction.detailTransaction.pembayaranUnit,
                salesProgramId: {
                  ...loadedData.dataTransaction.detailTransaction.pembayaranUnit
                    .salesProgramId,
                  ...selectedPromo,
                },
              },
            },
          },
        };
      }
    }
    let violationIds = shouldRecalculateOnLoad
      ? calculateFakturJualViolations(violationData)
      : headerViolationIds;

    if (
      shouldRecalculateOnLoad &&
      (await this.fetchUnitAgeViolation(violationData))
    ) {
      violationIds = [...new Set([...violationIds, "APPRV0016"])];
    }

    this.setState((prevState) => ({
      ...prevState,
      fjState: this.props.state.selectedData?.salesOrderState,
      namaPenjual: penjual,
      listIdPelanggaran: violationIds,
      data: {
        ...prevState.data,
        ...violationData,
      },
    }));
  };

  handleSave = async () => {
    let { tab } = this.props;
    if (this.state.isPoExist) {
      await this.resetNoPo();
    }
    let payload = JSON.parse(JSON.stringify(this.state.data));
    const constructPayload =
      tab === "NOS"
        ? service.constructSalesOrderRequestPayload(payload)
        : service.constructSalesOrderRequestDGI(payload);

    const req =
      tab === "NOS"
        ? {
            ...constructPayload,
            action: "SIMPAN",
            statusFakturJual: "FJ_DRAFT",
          }
        : {
            ...constructPayload,
            salesOrderSubmitRequestDTO: {
              ...constructPayload.salesOrderSubmitRequestDTO,
              action: "SIMPAN",
              statusFakturJual: "FJ_DRAFT",
            },
          };
    this.props.onSubmit(req);
  };

  validateMarketingLine = () => {
    return this.marketingLine === 0 && this.adminLine === 0;
  };

  validatePaymentCredit = (data) => {
    const {dibayarRumah,dibayarTunai,dibayarTransfer} = data || {}
    const checkNonZeroPayment = Object.values({dibayarRumah,dibayarTunai,dibayarTransfer}).filter((val) => parseInt(val) !== 0).length;
    return checkNonZeroPayment > 1
  }

  processConfirmOrder = async (overrideReferenceName) => {
    const { tab } = this.props;
    if (this.state.isPoExist) {
      await this.resetNoPo();
    }
    let payload = JSON.parse(JSON.stringify(this.state.data));
    const constructPayload =
      tab === "NOS"
        ? service.constructSalesOrderRequestPayload(payload)
        : service.constructSalesOrderRequestDGI(payload);
    const req =
      tab === "NOS"
        ? {
            ...constructPayload,
            action: this.state.listIdPelanggaran?.length > 0 ? "CONFIRM_ORDER_WITH_VIOLATION" : "CONFIRM_ORDER",
            listPelanggaran: this.state.listIdPelanggaran,
            statusFakturJual: "FJ_SUBMITTED",
          }
        : {
            ...constructPayload,
            salesOrderSubmitRequestDTO: {
              ...constructPayload.salesOrderSubmitRequestDTO,
              action: this.state.listIdPelanggaran?.length > 0 ? "CONFIRM_ORDER_WITH_VIOLATION" : "CONFIRM_ORDER",
              listPelanggaran: this.state.listIdPelanggaran,
              statusFakturJual: "FJ_SUBMITTED",
            },
          };
          
     if (overrideReferenceName) {
       if (tab === "NOS") {
         req.dataReferral = {
           ...(req.dataReferral || {}),
           name: this.state.namaPenjual,
           referralType: "SALESMAN",
         };
       } else {
         req.salesOrderSubmitRequestDTO = {
           ...req.salesOrderSubmitRequestDTO,
           dataReferral: {
             ...(req.salesOrderSubmitRequestDTO.dataReferral || {}),
             name: this.state.namaPenjual,
             referralType: "SALESMAN",
           },
         };
       }
     }else {
        if(tab === "NOS" && req.dataReferral !== null){
          req.dataReferral = {
            ...(req.dataReferral || {}),
            referralType: "CUSTOMER",
          }
        }
        if(tab==="DGI" && req.salesOrderSubmitRequestDTO.dataReferral !== null){
          req.salesOrderSubmitRequestDTO = {
            ...req.salesOrderSubmitRequestDTO,
            dataReferral: {
              ...(req.salesOrderSubmitRequestDTO.dataReferral || {}),
              referralType: "CUSTOMER",
            }
          } 
        }
     }

    let penjualIsMakelar = false;
    let isMakelarProfesional = false;

    if (tab === "NOS") {
      penjualIsMakelar =
        req.dataReferral?.name === this.state.namaPenjual &&
        this.state.namaPenjual !== null;
      isMakelarProfesional = req.dataReferral?.makelarProfessional;
    } else if (tab === "DGI") {
      penjualIsMakelar =
        req.salesOrderSubmitRequestDTO.dataReferral?.name ===
          this.state.namaPenjual && this.state.namaPenjual !== null;
      isMakelarProfesional =
        req.salesOrderSubmitRequestDTO.dataReferral?.makelarProfessional;
    }

    const dataTrx = tab === "DGI" ? req?.salesOrderSubmitRequestDTO?.dataTransaction : req?.dataTransaction;

    if(dataTrx.pembayaranUnit.tipePayment === "CREDIT"){
      if(this.validatePaymentCredit(dataTrx?.pembayaranKonsumen || {})){
        return  this.handleVisibleAlertInfo("Informasi", "Pembayaran untuk tipe pembayaran KREDIT hanya bisa salah satu.");
      }
    }

    const err =
      tab === "NOS"
        ? service.validate(req, penjualIsMakelar, isMakelarProfesional)
        : service.validateDGI(req, penjualIsMakelar, isMakelarProfesional);

    const { isMkNotNull, ...rest } = err;
    const isValid = Object.values(rest).every(
      (val) =>
        (typeof val === "object" && Object.keys(val).length === 0) || !val
    );
    

    if (!isValid) {
      this.handleShowAlert(
        rest.pembayaranKonsumen?.nilaiHarusSetor
          ? rest.pembayaranKonsumen?.nilaiHarusSetor
          : null
      );
      return this.setState((prevState) => ({
        ...prevState,
        errors: {
          ...prevState.errors,
          ...err,
        },
      }));
    }

    if (isMkNotNull && isValid) {
      return this.handleMkValidationVisibleVisibility();
    }

    this.setState((prevState) => ({
      ...prevState,
      mkValidationVisible: false,
    }));
    if (isValid) {
      this.props.onSubmit(req);
    }
  };

  resetNoPo = () => {
    this.setState((prevState) => ({
      ...prevState,
      data: {
        ...prevState.data,
        dataTransaction: {
          ...prevState.data.dataTransaction,
          detailTransaction: {
            ...prevState.data.dataTransaction.detailTransaction,
            pembayaranUnit: {
              ...prevState.data.dataTransaction.detailTransaction
                .pembayaranUnit,
              noPo: null,
            },
          },
        },
      },
    }));
  };

  verifyPoNumberLeasing = async (poNumber) => {
    if (poNumber) {
      let res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_TRANSACTION").verifyPoNumberLeasing,
        menuName: "Faktur Jual - Sales Order",
        setError: this.props.setError,
        args: contructQueryParam({ poNumberLeasing: poNumber }),
      });
      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        this.setState((prevState) => ({
          ...prevState,
          isPoExist: !res.data.data,
        }));
      }
    }
  };

  handleConfirmOrder = async () => {
    if (this.validateMarketingLine()) {
      return this.props.setError({
        menuName: `Detail Faktur Jual ${this.props.tab}`,
        errorMessage: "Anda tidak memiliki izin untuk melakukan proses ini",
      });
    }
    this.processConfirmOrder();
  };

  handleShowAlert = (additionalError) => {
    this.setState((prevState) => ({
      ...prevState,
      showAlert: !prevState.showAlert,
      additionalError,
    }));
  };

  handleClear = () => {
    setTimeout(() => {
      this.handleTriggerLoading();
    }, 500);
    this.setState((prevState) => ({
      ...prevState,
      data: {
        ...prevState.data,
        nomorFakturJual: uuidv4(),
        tanggalFakturJual: M(new Date()).format("DD-MM-YYYY"),
        jenisProspect: "NEW",
        kodeCabang: null,
        indentNo: null,
        prospectNo: null,
        dataPemilik: config.initialDataPemilik,
        dataPembeli: config.initialDataPembeli,
        dataPhoto: config.initialDataPhoto,
        dataUnit: config.initialDataUnit,
        dataPackage: {
          selectedPackage: null,
          selectedRow: null,
          dataTable: {
            ksu: [],
            hadiah: [],
            barangLain: [],
            part: [],
          },
          dataDetailSaved: {
            ksu: [],
            hadiah: [],
            barangLain: [],
            part: [],
          },
        },
        dataTransaction: config.initialDataTransaction,
        dataDelivery: config.initialDataDelivery,
        dataReferral: config.initialDataReferal,
        dataNote: config.initialDataNote,
      },
    }));
    this.handleTriggerLoading();
  };

  handleMkValidationVisibleVisibility = () => {
    this.setState((prevState) => ({
      ...prevState,
      mkValidationVisible: !prevState.mkValidationVisible,
    }));
  };

  handleAlertCancelOrDelete = (action) => {
    const isDelete = action === "delete";
    const txtAction = isDelete ? "dihapus" : "dibatalkan";

    this.setState((prevState) => ({
      ...prevState,
      alertCancelOrDelete:
        action === null
          ? null
          : {
              isDelete,
              title: isDelete
                ? "Warning Hapus Data FJ!"
                : "Cancel Order Warning!",
              content: `Data Order FJ ini akan ${txtAction} dan tidak bisa dirollback kembali. Apakah Anda yakin ingin melakukan hal ini?`,
            },
    }));
  };

  handleSuccessCancelOrDelete = (action) => {
    const isDelete = action === "delete";
    const content = isDelete
      ? "Data Order unit telah dihapus."
      : "Data Order unit beserta dengan proses lainnya telah direquest batal. Mohon tunggu approval.";
    const title = isDelete ? "Customer Sales Order" : "Cancel Order";

    if (action === null) {
      this.props.onReload();
    }

    this.setState((prevState) => ({
      ...prevState,
      alertCancelOrDelete:
        action === null
          ? null
          : {
              isSuccess: true,
              title: title,
              content: content,
            },
    }));
  };

  handleCloseAlertCancelOrDelete = () => {
    if (this.state.alertCancelOrDelete?.isSuccess) {
      return this.handleSuccessCancelOrDelete(null);
    }
    this.handleAlertCancelOrDelete(null);
  };

  handleDeleteOrCancelOrder = async (action) => {
    try {
      this.handleTriggerLoading();
      const statusFJ =
        action === "cancel" ? "FJ_CANCEL_APPROVED" : "FJ_DELETED";

      const api = action === "cancel" ? "cancelOrderFJ" : "salesOrderUpdateStatus"
      const payload =
        action === "cancel"
          ? this.props.state.selectedData?.nomorFJ
          : {
              nomorFakturJual: this.props.state.selectedData?.nomorFJ,
              statusFakturJual: statusFJ,
              unitStatus: action === "cancel" ? "CANCEL" : "DELETED",
            };

      const result = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_TRANSACTION")[api],
        menuName: "Faktur Jual - Sales Order",
        setError: this.props.setError,
        args: payload
      })
      
      if (result.ok && result.data.status === HttpStatus.SUCCESS) {
        this.handleSuccessCancelOrDelete(action);
      }
      this.handleTriggerLoading();
    } catch (error) {
      this.handleTriggerLoading();
      console.log(error);
    }
  };

  handlePelanggaran = (conditionToAdd, approvalCode) => {
    if (!this.shouldCalculateViolations()) return;

    this.setState((prev) => ({
      ...prev,
      listIdPelanggaran: conditionToAdd
        ? [...new Set([...(prev?.listIdPelanggaran || []), approvalCode])] || []
        : prev?.listIdPelanggaran?.filter((item) => item !== approvalCode) || [],
    }));
  };

  handleVisibleAlertInfo = (title,content) =>{
    this.setState((prev) => ({
      ...prev,
      alertInfo: {
        ...prev.alertInfo,
        visible: !prev.alertInfo.visible,
        title: title,
        content: content
      },
    }));
  }

  render() {
    return (
      <>
        <SimpleModal
          title={`Detail Faktur Jual - ${this.props.tab}`}
          visible={this.props.visible}
          onClickClose={this.props.onClickClose}
          content={
            <ModalContainer>
              <FakturJualDetailHeader
                {...this.props}
                errors={this.state.errors}
                data={this.state.data}
                cabangOptions={this.props.state.cabangOptions}
                onInputDataVisibility={this.handleInputDataVisibility}
                onSetState={this.handleSetState}
                isDraft={this.state.fjState === "FJ_DRAFT"}
              />
              <FakturJualDetailContent
                {...this.props}
                handlePelanggaran={this.handlePelanggaran}
                verifyPoNumberLeasing={this.verifyPoNumberLeasing}
                isPoExist={this.state.isPoExist}
                namaPenjual={this.state.namaPenjual}
                headerTab={this.props.tab}
                errors={this.state.errors}
                data={this.state.data}
                pelanggaran={this.state.listIdPelanggaran}
                onSetState={this.handleSetState}
                onValueChange={this.handleValueChange}
                fjState={this.state.fjState}
                isDraft={this.state.fjState === "FJ_DRAFT"}
              />
              {this.props.state.isEditable && (
                <FlexView
                  vAlignContent="center"
                  style={{
                    justifyContent: "space-between",
                    gap: "10px",
                    marginTop: 20,
                  }}
                >
                  <FlexView>
                    {this.state.fjState === "FJ_DRAFT" &&
                      this.props.state.userAccess?.deleteAccess && (
                        <SimpleButton
                          text="Hapus Data"
                          onClick={() =>
                            this.handleAlertCancelOrDelete("delete")
                          }
                          icon={<i className="fa fa-trash margin-right-10px" />}
                        />
                      )}
                  </FlexView>
                  <FlexView>
                    {Array.isArray(this.state.statusForCancel) &&
                      this.state.statusForCancel.includes(
                        this.state?.fjState
                      ) && (
                        <SimpleButton
                          text="Cancel Order"
                          onClick={() =>
                            this.handleAlertCancelOrDelete("cancel")
                          }
                          icon={
                            <i className="fa fa-times-circle margin-right-10px" />
                          }
                        />
                      )}
                  </FlexView>
                  <FlexView hAlignContent="right" style={{ gap: "10px" }}>
                    <SimpleButton text="Clear" onClick={this.handleClear} />
                    {(this.state.fjState === "DRAFT" ||
                      !this.props.selectedData) && (
                      <SimpleButton
                        text="Confirm Order"
                        icon={
                          <i className="fa fa-check-circle margin-right-10px" />
                        }
                        styles={{ width: "auto" }}
                        onClick={this.handleConfirmOrder}
                      />
                    )}
                    <SimpleButton
                      text="Simpan"
                      icon={<i className="fa fa-save margin-right-10px" />}
                      onClick={this.handleSave}
                    />
                  </FlexView>
                </FlexView>
              )}
            </ModalContainer>
          }
        />
        {this.state.inputDataVisible && (
          <FakturJualDetailDataInput
            {...this.props}
            visible={this.state.inputDataVisible}
            title={
              this.state.inputDataType === "Indent"
                ? "List Data Indent"
                : "List Data Prospek"
            }
            type={this.state.inputDataType}
            state={{
              kodeCabang: this.state.data.kodeCabang,
            }}
            tableColumns={
              this.state.inputDataType === "Indent"
                ? config.tableColumnDataIndent
                : config.tableColumnDataProspect
            }
            onSelect={this.handleSelectInputData}
            onClickClose={this.handleInputDataVisibility}
          />
        )}
        {this.state.alertInfo?.visible && (
          <SimpleAlert
            title={this.state.alertInfo?.title}
            visible={this.state.alertInfo?.visible}
            onClickClose={() => this.handleVisibleAlertInfo()}
            content={
              <p>
                {this.state.alertInfo?.content}
              </p>
            }
            additionalButtons={
                <SimpleButton onClick={() => this.handleVisibleAlertInfo()}>
                  Ok
                </SimpleButton>
            }
          />
        )}
        {this.state.mkValidationVisible && (
          <SimpleAlert
            title="Information"
            visible={this.state.mkValidationVisible}
            onClickClose={() => this.handleMkValidationVisibleVisibility()}
            content={
              <p>
                Nama Penjual akan digunakan sebagai Makelar. Apakah anda yakin?
              </p>
            }
            additionalButtons={
              <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                <SimpleButton
                  onClick={() => this.handleMkValidationVisibleVisibility()}
                >
                  Batal
                </SimpleButton>
                <SimpleButton onClick={() => this.processConfirmOrder(true)}>
                  Iya
                </SimpleButton>
              </FlexView>
            }
          />
        )}
        {this.state.showAlert && (
          <SimpleAlert
            title="Information"
            visible={this.state.showAlert}
            onClickClose={() => this.handleShowAlert(null)}
            content={
              <div>
                <p>Ada field yang belum diisi. Silakan dicek kembali.</p>
                <p>{this.state.additionalError}</p>
              </div>
            }
            additionalButtons={
              <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                <SimpleButton onClick={() => this.handleShowAlert(null)}>
                  OK
                </SimpleButton>
              </FlexView>
            }
          />
        )}
        {this.state.alertCancelOrDelete && (
          <SimpleAlert
            visible={this.state.alertCancelOrDelete !== null}
            title={this.state.alertCancelOrDelete?.title || "Information"}
            onClickClose={() => this.handleCloseAlertCancelOrDelete()}
            content={
              <div>
                {this.state.alertCancelOrDelete?.content}
                <br />
                {this.state.alertCancelOrDelete?.isSuccess ? (
                  <SimpleButton
                    style={{ marginTop: "20px" }}
                    onClick={() => this.handleSuccessCancelOrDelete(null)}
                  >
                    OK
                  </SimpleButton>
                ) : (
                  <FlexView
                    vAlignContent="center"
                    hAlignContent="center"
                    style={{ gap: "10px", marginTop: "20px" }}
                  >
                    <SimpleButton
                      onClick={() => this.handleAlertCancelOrDelete(null)}
                    >
                      Batal
                    </SimpleButton>
                    <SimpleButton
                      onClick={() =>
                        this.handleDeleteOrCancelOrder(
                          this.state.alertCancelOrDelete?.isDelete
                            ? "delete"
                            : "cancel"
                        )
                      }
                    >
                      Ya
                    </SimpleButton>
                  </FlexView>
                )}
              </div>
            }
          />
        )}
        {this.state.loading && (
          <SimpleLoadingOverlay active={this.state.loading} />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.user,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withFormGroup(FakturJualDetail));
